import { Component, OnInit, EventEmitter, Output, Input, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATA_MODE_NAMES, DataOverlay, VectorLayerDescriptor } from '../data';
import { environment } from '../../environments/environment';
import { LegendUtils } from '../legend-utils';
import FileSaver from 'file-saver';
import { ZonalService } from '../zonal.service';
import { Bounds } from 'map-wald';
import { DataDownloadService } from 'terrakio';
import { FeatureUtils } from 'projects/map-wald-leaflet/src/lib';

const INITIAL_PAGES={
  grid:0,
  choropleth:1,
  points:2
};

const BYTES_TO_MB = 1/1024/1024;
const MAX_AREA_SQ_DEGREES = 2500;

@Component({
  selector: 'app-download-form',
  templateUrl: './download-form.component.html',
  styleUrls: ['./download-form.component.scss']
})
export class DownloadFormComponent implements OnInit, AfterViewInit {
  @Input() mapConfiguration: DataOverlay;
  @Input() choroplethMode: boolean;
  @Input() boundaries: VectorLayerDescriptor;
  @Input() bounds: Bounds;
  @Input() featureLabel: string;
  @Input() feature: GeoJSON.Feature<GeoJSON.GeometryObject>;
  @Output() submitted = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  initial = 0;
  step = 0;
  mode: 'grid' | 'choropleth' | 'points' | null;
  pointURL: string;
  geojsonURL: string;
  geojsonSizeMb: number;
  squareDegrees: number;
  tooBig = false;
  requestResult: string;
  resultType: string;
  name:string;
  email:string;
  reasonForRequest:string;
  dataExpression:string;
  areaOfInterest:string;

  constructor(private http: HttpClient, private zonal:ZonalService, private download: DataDownloadService) { }
  ngAfterViewInit(): void {
    this.reset();
  }

  ngOnInit(): void {
  }

  getBounds(): Bounds {
    if(!this.feature||!this.featureLabel){
      return this.bounds;
    }
    return {
      north: this.feature.properties.maxy,
      south: this.feature.properties.miny,
      east: this.feature.properties.maxx,
      west: this.feature.properties.minx
    };
  }

  reset(): void {
    this.mode = null;
    if(!this.mapConfiguration){
      return;
    }

    const overlay = this.mapConfiguration;
    console.log(overlay);
    if(this.choroplethMode){
      this.mode = 'choropleth';
    }
    else if(overlay.points?.features?.features?.length){
      this.mode = 'points';
      let pointFile:string;
      if(overlay.selection.variant?.combine){
        pointFile = (overlay.selection.flattened.variants.find(v=>!v.combine) as any)?.filename;
      } else {
        pointFile = (overlay.selection.variant as any).filename;
      }
      pointFile = directoryName(pointFile);
      this.pointURL = `${environment.tds}/catalog/${pointFile}/catalog.html`;
    } else if(overlay.wms?.url){
      this.mode = 'grid';
      this.dataExpression = overlay?.wms?.params?.expression;
      let bounds = this.getBounds();
      if(this.feature&&this.featureLabel){
        const source:string = this.feature.properties.source;
        this.areaOfInterest = `${source}: ${this.featureLabel}\n`;
      } else {
        this.areaOfInterest='';
      }
      this.areaOfInterest += Object.keys(bounds).map(k=>`${k}: ${(bounds as any)[k].toFixed(3)}`).join(', \n');

      this.squareDegrees = Math.abs(bounds.east-bounds.west)*Math.abs(bounds.north-bounds.south);
      this.tooBig = this.squareDegrees>MAX_AREA_SQ_DEGREES;
    } else {
      this.mode = 'choropleth';
    }

    if(this.mode==='choropleth'){
      this.geojsonURL = `${environment.highQualityGeoJSONs}/${this.boundaries.filename}.json`;
      this.geojsonSizeMb = +(this.boundaries.filesize * BYTES_TO_MB).toFixed();
    }

    this.initial = INITIAL_PAGES[this.mode];
    this.step = this.initial;
  }

  submit(): void {
    // const post$ = this.http.post(environment.registration,{
    //     email: this.emailAddress,
    //     updates:this.subscribe
    // },{
    //   responseType:'text'
    // });
    // // const post$ = of(null);
    // post$.subscribe(res=>{
    //   this.submitted.emit();
    // });
  }

  validate(): void {
    // this.valid = !!this.emailAddress.match(EMAIL_REGEXP);
  }

  downloadMapImage(): void {
    // this.optionsChanged.emit({
    //   downloadImage: true
    // });
  }

  downloadMapData(): void {
    // this.optionsChanged.emit({
    //   downloadData: true
    // });
  }

  downloadCurrentChoroplethView(): void {
    const values = this.mapConfiguration.choropleth.values;
    const description = LegendUtils.describeLegend(this.mapConfiguration,true);
    const filename =
      `${this.mapConfiguration.selection.flattened.label}-${DATA_MODE_NAMES[this.mapConfiguration.selection.dataMode]}.csv`
      .replace(/ /g,'-');
    const lines = [`"${description.explanation}"`].concat(
      Object.keys(values)
        .filter(k=>k!=='date')
        .map(k=>`${k},${values[k]}`));
    this.downloadCSV(filename,lines.join('\n'));
  }

  downloadMonthlyZonalStatistics(): void {
    this.downloadSomething();
    const layer = this.mapConfiguration.selection.flattened;
    const boundaries = this.boundaries.zonal;
    this.zonal.getRaw(layer,boundaries).subscribe(data=>{
      const columns = ['date'].concat(Object.keys(data[0]).filter(k=>k!=='date'));
      const bodyLines = data.map(row=>{
        return columns.map((k,i)=>i?row[k]:(row[k] as Date).toLocaleDateString()).join(',');
      });
      const lines = [columns.join(',')].concat(bodyLines);
      this.downloadCSV(`${layer.label}-${boundaries}.csv`,lines.join('\n'));
    });
  }

  downloadSomething(): void {
    console.log(this.boundaries);
    console.log(this.mapConfiguration);
    console.log(this.mode);
  }

  downloadData(mode:string):void {

  }

  downloadCSV(filename:string,data:string):void {
    const output = new Blob(
      [data],
      {type: 'text/plain;charset=utf-8'});
    FileSaver.saveAs(output, filename);
  }

  downloadBoundaries(): void {
    console.log(this.boundaries);
    const url = `${environment.highQualityGeoJSONs}/${this.boundaries.filename}.json`;
    console.log(url);
  }

  close(): void {
    this.closed.emit();
  }

  sendDataRequestEmail(): void {
    const email = environment.feedbackAddress;
    const name = this.name;
    const reason = this.reasonForRequest;
    const dataExpression = this.dataExpression;

    const subject = "GWM Gridded Data Request";
    const body = `
        Request details:\n
Name:		${name}\n
        Reason for Request: 		${reason}\n
        Current map data:\n
${dataExpression}
        Area of Interest:\n
${this.areaOfInterest}
    `.trim();

    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
 }

 requestData(): void {
  this.requestResult = null;
  const bounds = this.getBounds();
  const url = environment.downloadService;
  const description = LegendUtils.describeLegend(this.mapConfiguration,true);
  const body = {
    email: this.email,
    name: this.name,
    north: bounds.north,
    south: bounds.south,
    east: bounds.east,
    west: bounds.west,
    selectedFeature: this.featureLabel,
    expression: this.dataExpression,
    reason: this.reasonForRequest,
    mapTitle: description.explanation
  };
  this.http.post(url,body).subscribe((res:any)=>{
    console.log(res);
    if(res?.status==='success'){
      this.requestResult = 'Request submitted successfully. You will receive an email with a link to download the data. If you do not receive an email, please check your spam folder.';
      this.resultType = res?.status;
    } else if(res?.status==='error'){
      this.requestResult = res?.message || 'An error occurred while processing your request. Please try again later.';
      this.resultType = res?.status;
    }
  });
 }

 directGridDownload(): void{
  const b = this.getBounds();
  const label = LegendUtils.describeLegend(this.mapConfiguration,false);
  let fn = label.explanation.replace(/ +/g,'-').replace(/[^a-zA-Z0-9-]/g,'');
  fn = `GWM-download-${fn}.tif`;
  console.log(label);
  const feature = FeatureUtils.makeSquareFeatureFromBounds(b.west,b.south,b.east,b.north);
  this.download.forPolygon(feature,this.mapConfiguration.selection.flattened,this.dataExpression).subscribe(buffer=>{
    console.log(buffer);
    const url = window.URL.createObjectURL(buffer); // create a new object url
    const a = document.createElement("a"); // create a new anchor element
    a.href = url; // set its href to the object URL
    a.download = fn;  // set its download attribute to the deisred filename.
    a.click();
  });
 }
}

function directoryName(pointFile: string): string {
  return pointFile.split('/').slice(0,-1).join('/');
}


